export default "__VITE_ASSET__hZ5J3NKI__"